// extracted by mini-css-extract-plugin
export default {"similarityResult":"CAg3Q3ZEHYAkBg_MTBOQ"};